const smtIconCardComponent = {
  color: {
    default: 'gray.600',
    _dark: 'gray.400'
  },
  bgColor: {
    default: 'transprent',
    _dark: 'gray.800'
  },
  borderColor: {
    default: 'gray.200',
    _dark: 'gray.700'
  },
  hover: {
    color: {
      default: 'gray.800',
      _dark: 'gray.300'
    },
    bgColor: {
      default: 'rgb(248, 250, 252)',
      _dark: 'gray.700'
    },
    borderColor: {
      default: 'gray.300',
      _dark: 'gray.600'
    }
  }
};

export default smtIconCardComponent;
